import { Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy } from '@angular/core';
@Pipe({
    name: 'calculatedRatio',
    pure: false
})
export class CalculatedRatioPipe implements PipeTransform {
    constructor() { }
    transform(item: any, firstFiled: string, secondFiled: string, key: string) {
        const first = +item[firstFiled] || 0;
        const second = +item[secondFiled] || 0;
        let result = '';
        if (second && first) {
            const ratio = second % first > 0 ? (second / first).toFixed(1) : (second / first);
            result = ratio + ':' + 1;
        } else {
            result = '0:0';
        }
        if (key) item[key] = result;
        return result;
    }
}